import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List } from "immutable";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getPurchaseInvoices, cleanPurchaseInvoices } from "../../../actions/purchase-invoices";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class PurchaseOrderInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            purchaseInvoiceFilters: ''
        };
    }
    componentDidMount() {
        this.props.getPurchaseInvoices({
            filters: {
                orders: this.props.purchaseOrder.get('_id')
            },
            projection: 'invoice_code document_date expiration_date supplier statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'supplier',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'purchase-invoices'
        });
    }
    componentWillUnmount() {
        this.props.cleanPurchaseInvoices();
    }

    render() {
        let tableData = this.props.purchaseInvoices;

        // Filters Zone
        let totalInvoices = 0, totalUnpaid = 0;
        this.props.purchaseInvoices.forEach(invoice => {
            if (invoice.get('status') === 'unpaid') {
                totalUnpaid = totalUnpaid + invoice.getIn(['statistics', 'total']);
            }
            totalInvoices = totalInvoices + invoice.getIn(['statistics', 'total']);
        });
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label ">{ numeral(totalInvoices).format() }</span>
                    <span>Total facturas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                    <span>Total pendiente</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.purchaseInvoices.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }><strong>Facturas</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }>Pagadas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                </div>
                { this.props.canNewInvoice
                    ? <div className="col-auto ml-auto">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.props.history.push('/compras/facturas/nuevo', {
                                purchaseOrder: this.props.purchaseOrder
                            })}
                        >
                            <Icon icon="insert"/>Factura
                        </button>
                    </div>
                    : null
                }
            </div>
        );

        switch (this.state.purchaseInvoiceFilters) {
            case 'paid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }><strong>Pagadas</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                        </div>
                        { this.props.canNewInvoice
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/facturas/nuevo', {
                                        purchaseOrder: this.props.purchaseOrder
                                    })}
                                >
                                    <Icon icon="insert"/>Factura
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseInvoices.filter( purchaseInvoice => purchaseInvoice.get('status') === 'paid' );
                break;
            case 'unpaid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }>Pagadas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }><strong>Pendientes</strong></span>
                        </div>
                        { this.props.canNewInvoice
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/compras/facturas/nuevo', {
                                        purchaseOrder: this.props.purchaseOrder
                                    })}
                                >
                                    <Icon icon="insert"/>Factura
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.purchaseInvoices.filter( purchaseInvoice => purchaseInvoice.get('status') === 'unpaid' );
                break;
            default:
                break;
        }

        // PurchaseInvoices Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            invoice_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'invoice_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/facturas/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expiration_date: {
                title: "Fecha de vencimiento",
                columnType: 'date',
                dataField: 'expiration_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'unpaid':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'paid':
                            data.badgeColor = 'primary';
                            data.value = 'Pagado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/facturas/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                { statsZone }
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const purchaseInvoicesReducer = state.purchaseInvoices;

    // PurchaseInvoices
    let purchaseInvoices = purchaseInvoicesReducer.get('payload') || List([]);

    if (!(purchaseInvoices instanceof List)) {
        purchaseInvoices = List([])
    }

    return {
        purchaseInvoices
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPurchaseInvoices: (query) => dispatch(getPurchaseInvoices(query)),
        cleanPurchaseInvoices: () => dispatch(cleanPurchaseInvoices())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderInvoices);



// WEBPACK FOOTER //
// ./src/containers/purchases/orders/PurchaseOrderInvoices.js